export class Shuffler<T> {
  private items: T[];
  private bag: T[];

  constructor(items: T[]) {
    this.items = items;
    this.bag = [];
  }

  pop(): T {
    this.ensureBagHasItems();
    return this.bag.shift()!;
  }

  peek(): T {
    this.ensureBagHasItems();
    return this.bag[0];
  }

  private ensureBagHasItems(): void {
    while (this.bag.length < 2) {
      this.fillBag();
    }
  }

  private fillBag(): void {
    const newItems = this.items.slice();
    newItems.sort(() => Math.random() - 0.5);
    this.bag = this.bag.concat(newItems);
  }
}